import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Platform, IonCol, IonContent, IonInput, IonItem, IonLabel, IonList, IonRow } from '@ionic/angular';
import {ApiService, ExclusionService, NetworkService} from '../../services/services';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
// import {Echo} from 'laravel-echo-ionic';
import {environment as ENV} from '../../../environments/environment';
import {WebFooterComponent} from '../../components/web-footer/web-footer.component';
import {FormsModule} from "@angular/forms";
import {NgClass} from "@angular/common";
import { Dialog } from '@capacitor/dialog';
import {AmplitudeService} from "../../services/amplitude/amplitude.service";
import {Capacitor} from '@capacitor/core';
import {nativeAppVersion, packageAppVersion} from '../../utils/app-version';
import {
  cachePasswordCredential,
  clearPasswordCredential,
  NativeCredentialManager,
  PasswordCredential
} from '../../plugins/native-credential-manager';


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-welcome',
  templateUrl: './welcome.page.html',
  imports: [
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonInput,
    FormsModule,
    IonRow,
    IonCol,
    NgClass,
    WebFooterComponent
  ],
  styleUrls: ['./welcome.page.scss']
})
export class WelcomePage implements OnInit {
  appVersion = packageAppVersion;
  privacyPolicy = '';
  termsAndConditions = '';
  loginWrapper = false;
  //@ts-ignore
  account: { email: string; userId: any; photoVerificationRequired: boolean; token: any; ucn: any; password: any} = {
    email: '',
    userId: null,
    photoVerificationRequired: false,
    token: null,
    ucn: null,
    password: '',
  };
  echo: any;
  config = ENV;
  isNative = Capacitor.isNativePlatform();
  private credentialRequestInProgress = false;
  private credentialRequestAttempted = false;
  private selectedCredential: PasswordCredential | null = null;
  constructor(
    public plt: Platform,
    public api: ApiService,
    private router: Router,
    public networkServ: NetworkService,
    public excl: ExclusionService,
    private route: ActivatedRoute,
  ) {
    this.route.queryParamMap.subscribe(params => {
      //@ts-ignore
      this.account.email = params.get('email');
      // this.account.email = ''
      console.log('this.account',this.account);
    });
    // this.initEcho();
  }

  ngOnInit() {
    nativeAppVersion().then(info => this.appVersion = info);
    this.plt.ready().then((readySource) => {
      this.api.getLegalInformation().subscribe((res) => {
        this.privacyPolicy = res.data.privacy_policy;
        this.termsAndConditions = res.data.terms_and_conditions;
        // FIREBASE ANALYTICS SCREEN
        // this.firebaseStats.sendEvent('screen_view', {screen_name: "Welcome_Screen", screen_class: "Welcome"});
      });

    });
  }

  ionViewWillEnter(): void {
    this.credentialRequestInProgress = false;
    this.credentialRequestAttempted = false;
    this.selectedCredential = null;
    clearPasswordCredential();
  }

  async loadEmailCredential(): Promise<void> {
    if (
      Capacitor.getPlatform() !== 'android' ||
      this.credentialRequestInProgress ||
      this.credentialRequestAttempted
    ) {
      return;
    }

    this.credentialRequestAttempted = true;
    this.credentialRequestInProgress = true;
    this.selectedCredential = null;
    clearPasswordCredential();

    try {
      const credential = await NativeCredentialManager.getPassword();
      this.selectedCredential = credential;
      this.account.email = credential.username;
    } catch {
      // No credential is saved for this app or the user dismissed the picker.
    } finally {
      this.credentialRequestInProgress = false;
    }
  }

  //@ts-ignore
  async checkUserEmail(form) {
    //internet connection check
    console.log('form', form);
    if(!form.valid) {return false;}
    const conn: any = await this.networkServ.checkInternet();
    console.log('conn', conn);
    if (!conn.result) {
      return false;
    }

    this.api.signUpCheck(this.account.email, true).subscribe(async (res) => {
      console.log('signUpCheck res', res);
      if(res.apiCode == 'SUCCESS' && res.apiStatus == 'OK'){
        if(res.data.result){
          // this.Goto('LoginPage', {account: {email: this.account.email}});
          this.goTo('login', {email: this.account.email});
        }else {
          this.goTo('registration', {account: {email: this.account.email}});
        }
      }
    }, async (e) => {
      if (e.error.apiCode == 'VALIDATION' && e.error.apiStatus == 'FAIL') {
        let errMessage = '';
        e.error.errors.email.forEach((error) => errMessage += error + '\n');
        await Dialog.alert({
          title: 'Match15',
          message: errMessage,
          buttonTitle: 'Ok'
        });
      }
    });

  }




  goTo(page: string, params?) {
    if (
      page === 'login' &&
      this.selectedCredential &&
      this.selectedCredential.username.trim().toLowerCase() ===
        this.account.email.trim().toLowerCase()
    ) {
      cachePasswordCredential(this.selectedCredential);
    } else {
      clearPasswordCredential();
    }

    const navigationExtras: NavigationExtras = {
      queryParams:  {email: this.account.email}
    };
    this.router.navigate([page], navigationExtras);
  }

  // initEcho() {
  //   const pusherConfig = {
  //     broadcaster: 'pusher',
  //     key: ENV.pusherKey,
  //     cluster: 'eu',
  //     forceTLS: true,
  //   };
  //   this.echo = new Echo(pusherConfig);
  //   // console.log("echo debug - this.echo: " + JSON.stringify(this.echo));
  // }




}
